import classNames from 'classnames';

import { IconEmpty } from '@/components/icons/icons';

import styles from './styles.module.less';

const Empty = ({ theme }) => {
  return (
    <div className={classNames(styles.box, theme)}>
      <IconEmpty className={styles.icon} />
      <div className={classNames(styles.text, theme)}>Empty</div>
    </div>
  );
};

export default Empty;
